/**
 * FritsDigestWidget — "Dagelijkse check". De laatste GPT-inzichten van de
 * dagelijkse PL-check (projecten, deadlines, klaargezette taakvoorstellen).
 * Zelfde inhoud als de ochtend-push, maar terugleesbaar op het dashboard.
 * Databron: Node GET /Api/tasks/digest (engine bewaart de laatste per PL).
 */
import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { BACKEND_URL } from '../../../utils/apiConfig';
import { authFetch } from '../../../utils/authHelpers';
import { T } from './widgetTokens';

const fmtWhen = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const today = new Date();
    if (d.toDateString() === today.toDateString()) {
      return `vandaag ${d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}`;
    }
    return d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
  } catch { return ''; }
};

export default function FritsDigestWidget() {
  const [data, setData] = useState(null); // null = laden
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    authFetch(`${BACKEND_URL}/Api/tasks/digest`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('fetch failed'))))
      .then((d) => { if (active) setData(d || {}); })
      .catch(() => { if (active) { setError(true); setData({}); } });
    return () => { active = false; };
  }, []);

  if (data === null) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={18} sx={{ color: T.outlineVariant }} /></Box>;
  }
  if (error) {
    return <Typography sx={{ fontFamily: T.fontBody, fontSize: '0.82rem', color: T.outline }}>Dagelijkse check kon niet geladen worden.</Typography>;
  }
  if (!data.insight) {
    return (
      <Typography sx={{ fontFamily: T.fontBody, fontSize: '0.82rem', color: T.outline }}>
        Nog geen dagelijkse check — die komt elke ochtend automatisch zodra je actieve projecten hebt.
      </Typography>
    );
  }

  const meta = data.meta || {};
  return (
    <Box>
      <Typography sx={{ fontFamily: T.fontBody, fontSize: '0.86rem', color: T.text, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
        {data.insight}
      </Typography>
      <Typography sx={{ fontFamily: T.fontBody, fontSize: '0.68rem', color: T.outline, mt: 1 }}>
        {[
          fmtWhen(data.updated_at),
          meta.projects ? `${meta.projects} projecten` : '',
          meta.proposals ? `${meta.proposals} taakvoorstel${meta.proposals === 1 ? '' : 'len'} klaar` : '',
        ].filter(Boolean).join(' · ')}
      </Typography>
    </Box>
  );
}
